// src/components/PersonalProjectsPage.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './PersonalProjectsPage.css';
import { LanguageContext } from '../translations/LanguageContext';
import Footer from '../components/Footer'; // Importing the Footer component

function PersonalProjectsPage() {
  const { language, translations } = useContext(LanguageContext);
  const pageContent = translations[language].personalProjectsPage;

  return (
    <div className="personal-project-page">
      <div className="personal-hero-section">
        <h1 className="personal-hero-title">{pageContent.title}</h1>
        <div className="personal-hero-text">
          <p>
            {pageContent.lines[0]}<br />
            {pageContent.lines[1]}<br />
            <span className="faded-text">
              {pageContent.lines[2]}<br />
              {pageContent.lines[3]}
            </span>
          </p>
        </div>
      </div>

      <div className="personal-project-grid">
        {/* Circa */}
        <Link to="/personal-projects/circa" className="personal-project-link">
          <div className="personal-project-card">
            <img
              src="/assets/Circa.png"
              alt="Circa Project"
              className="personal-project-image"
            />
            <p className="personal-project-label">{pageContent.project1}</p>
          </div>
        </Link>
        {/* Paper Soccer - now with Link for navigation */}
        <Link to="/personal-projects/paper-soccer" className="personal-project-link">
          <div className="personal-project-card">
            <img
              src="/assets/PaperSoccer.png"
              alt="Paper Soccer Game"
              className="personal-project-image"
            />
            <p className="personal-project-label">{pageContent.project2}</p>
          </div>
        </Link>
        {/* Dot2D - Now with Link for navigation */}
        <Link to="/personal-projects/dot2d" className="personal-project-link">
          <div className="personal-project-card">
            <img
              src="/assets/Dot2D.png"
              alt="Dot2D Game"
              className="personal-project-image"
            />
            <p className="personal-project-label">{pageContent.project3}</p>
          </div>
        </Link>
        {/* Project Placeholder 3 */}
        {/* <div className="personal-project-card">
          <img
            src="/ProjectPlaceholder.png"
            alt="Project Placeholder"
            className="personal-project-image"
          />
          <p className="personal-project-label">{pageContent.placeholderLabel}</p>
        </div> */}
      </div>

      {/* Replaced the footer with the Footer component */}
      <Footer />
    </div>
  );
}

export default PersonalProjectsPage;
